import { AlertTriangle, ArrowRight, CheckCircle2, Hourglass, Inbox, Info, Target } from 'lucide-react'
import { Link } from 'react-router'
import { cn } from '@/lib/utils'
import type { Alert } from './alerts'

const ICON = { loss: Hourglass, goal: Target, decision: CheckCircle2, approval: Inbox, info: Info }

export function AlertRow({ alert, compact }: { alert: Alert; compact?: boolean }) {
  const Icon = alert.tone === 'danger' && alert.kind === 'decision' ? AlertTriangle : ICON[alert.kind]
  return (
    <Link to={alert.to} className="group flex items-start gap-3 rounded-lg px-3 py-2.5 transition-colors hover:bg-hover">
      <span
        className={cn(
          'mt-0.5 flex size-7 shrink-0 items-center justify-center rounded-full [&_svg]:size-3.5',
          alert.tone === 'danger' && 'bg-danger-soft text-danger',
          alert.tone === 'warning' && 'bg-warning-soft text-warning',
          alert.tone === 'success' && 'bg-success-soft text-success',
          alert.tone === 'accent' && 'bg-accent-soft text-accent',
          alert.tone === 'neutral' && 'bg-muted text-fg-muted',
        )}
      >
        <Icon aria-hidden />
      </span>
      <span className="min-w-0 flex-1">
        <span className="block text-sm font-medium">{alert.title}</span>
        {alert.body && <span className={cn('block text-fg-muted', compact ? 'text-xs' : 'text-sm')}>{alert.body}</span>}
      </span>
      {alert.cta && !compact ? (
        <span className="mt-0.5 hidden shrink-0 items-center gap-1 text-xs font-medium text-accent sm:flex">
          {alert.cta} <ArrowRight className="size-3.5" />
        </span>
      ) : (
        <ArrowRight className="mt-1 size-3.5 shrink-0 text-fg-subtle opacity-0 transition-opacity group-hover:opacity-100" />
      )}
    </Link>
  )
}
